import type { RevampCreative } from 'dataQueries/purchaseFlowRevampCreatives.query'
import type { CtBookingChosenPayload, CtBookingOpenedPayload } from '../../analytics'

/** What the creative list offered when the client opened it: how many, and the travel-cost range it quoted. */
export const ctBookingOpenedPayload = (creatives: RevampCreative[], isSubscribed: boolean): CtBookingOpenedPayload => {
  const travelCosts = creatives.flatMap((creative) => creative.travelCost ? [creative.travelCost] : [])
  return {
    creativeCount: creatives.length,
    lowestTravelCost: travelCosts.length ? Math.min(...travelCosts.map((cost) => cost.amount)) : undefined,
    highestTravelCost: travelCosts.length ? Math.max(...travelCosts.map((cost) => cost.amount)) : undefined,
    currency: travelCosts[0]?.currency,
    isSubscribed,
  }
}

/** The creative the client picked, with the travel cost as legacy sent it (amount and currency in one string). */
export const ctBookingChosenPayload = (id: string, creative: RevampCreative | undefined, isSubscribed: boolean): CtBookingChosenPayload => ({
  creativeId: id,
  creativeFullName: creative?.fullName,
  travelCost: creative?.travelCost ? `${creative.travelCost.amount} ${creative.travelCost.currency}` : undefined,
  isSubscribed,
})
